import { useQuery } from '@tanstack/react-query';
import { MultipleHouseHoldType } from '../type/twoFactor';
import { familyApprovalApi } from 'service/api/familyApprovalApi';
import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { consultationFamilyApprovalApi } from '../service/api/consultationFamilyApprovalApi';
import { permissions } from '@dvag/dfs-constant-config';
import { checkException, TError } from 'config/reactQuery';

const getFamilyApproval = async (
  payload: MultipleHouseHoldType,
  isConsultationServiceEnabled: boolean,
) => {
  const familyApprovalService = isConsultationServiceEnabled
    ? consultationFamilyApprovalApi()
    : familyApprovalApi();

  const response = await familyApprovalService.getMultipleHouseholdPerPerson(payload);
  return response.data;
};

export const useGetMultipleHouseHoldPerPerson = (
  householdId?: string,
  customerPersonId?: string,
  isEnabled = false,
) => {
  const isConsultationServiceEnabled = useFeatureIsOn(permissions.canAccessConsultationService);
  return useQuery({
    queryKey: ['multiple-household', customerPersonId],
    queryFn: () =>
      getFamilyApproval({ householdId, customerPersonId }, isConsultationServiceEnabled),
    enabled: !!customerPersonId && !!householdId && isEnabled,
    throwOnError: (err: TError) => checkException(err),
  });
};
